import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, MessageCircle } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "./ui/sheet";
import { Logo } from "./Logo";
import { NAV, waLink } from "../lib/site";

const linkCls = ({ isActive }) =>
  `nav-link relative py-2 text-[13px] font-semibold uppercase tracking-[0.12em] transition-colors ${
    isActive ? "text-brand is-active" : "text-ink hover:text-brand"
  }`;

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="site-header" className="sticky top-0 z-50 border-b border-line bg-white/90 backdrop-blur-md">
      <div className="container-x flex h-16 items-center justify-between lg:h-[72px]">
        <Link to="/" data-testid="header-logo-link" aria-label="SOLLUS — Página inicial"><Logo /></Link>
        <nav className="hidden items-center gap-7 lg:flex" data-testid="desktop-nav">
          {NAV.map((n) => (
            <NavLink key={n.id} to={n.path} end={n.path === "/"} className={linkCls} data-testid={`nav-link-${n.id}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <a href={waLink()} target="_blank" rel="noreferrer" data-testid="header-whatsapp-btn"
          className="btn-red !hidden xl:!inline-flex"><MessageCircle className="h-4 w-4" /> Orçamento</a>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button className="grid h-10 w-10 place-items-center rounded-md border border-line lg:hidden" data-testid="mobile-menu-btn" aria-label="Abrir menu">
              <Menu className="h-5 w-5" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[300px] bg-white" data-testid="mobile-menu">
            <SheetTitle className="mb-6"><Logo /></SheetTitle>
            <nav className="flex flex-col">
              {NAV.map((n) => (
                <NavLink key={n.id} to={n.path} end={n.path === "/"} onClick={() => setOpen(false)}
                  data-testid={`mobile-nav-link-${n.id}`}
                  className={({ isActive }) => `border-b border-line py-4 text-sm font-semibold uppercase tracking-[0.12em] ${isActive ? "text-brand" : "text-ink"}`}>
                  {n.label}
                </NavLink>
              ))}
            </nav>
            <a href={waLink()} target="_blank" rel="noreferrer" className="btn-red mt-8 w-full justify-center" data-testid="mobile-menu-whatsapp-btn">
              <MessageCircle className="h-4 w-4" /> Solicitar orçamento
            </a>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
};
